import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import moment from "moment";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Form,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { Formik, Field, ErrorMessage } from "formik";
import debounce from "lodash/debounce";
import "assets/scss/table.scss";

//Import Breadcrumb
import * as Yup from "yup";
import Breadcrumbs from "components/Common/Breadcrumb";
import {
  getSchemeAnalytesList,
  postMicroResult,
  // getResultsList,
  getmicroresultdata,
} from "store/results/actions";
import * as XLSX from "xlsx";

import "assets/scss/table.scss";
import { round } from "lodash";
import CycleList from "store/cycle/reducer";

class MicroResults extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.node = React.createRef();

    this.state = {
      ReagentList: [],
      Instrument: [],
      SchemeAnalytesList: [],
      combinedData: [],
      submittedOn: null,
      list: "",
      instrument_name: "",
      selectedReagentAST: "",
      currentLabId: "",
      organism: "",
      antibiotic: "",
      Antibiotic: [],
      reagent_name: "",
      result: "",
      schemeName: "",
      microresults: "",
      selectedFile: null,
      selectedFileName: "",
      schemeType: "",
      comments: "",
      roundLoadedFor: null,
      loading: true,
      round_status: "",
      result_status: "Created",
      rounds: "",
      issue_date: "",
      closing_date: "",
      cycle_no: "",
      isResubmitted: false,
      PostResult: [],
      fileMissing: false,
      currentRoundId: props.match.params.id,
      ResultList: [],
      isDataLoaded: false,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
  }
  downloadFile = (file) => {
    if (!file) {
      console.log("downloadFile called with null");
      return;
    }

    let url;
    if (file instanceof File) {
      // If it's a File object from input
      url = URL.createObjectURL(file);
    } else {
      // If it's already a URL
      url = file;
    }

    console.log("downloadFile - url:", url);

    const link = document.createElement("a");
    link.href = url;
    link.download = file.name || url.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    if (file instanceof File) {
      URL.revokeObjectURL(url);
    }
  };

  // fetchResults = async () => {
  //   try {
  //     const id = this.props.match.params.id;
  //     console.log("🔄 Fetching latest results...");
  //     await this.props.onGetResultsList(id);
  //     console.log("✅ Latest results fetched");
  //   } catch (error) {
  //     console.error("❌ Error fetching results", error);
  //   }
  // };
  getApprovedLabListColumns = () => {
    const { schemeType } = this.props;

    if (schemeType === "Identification") {
      return [
        {
          text: "Antibiotic ",
          dataField: "antibiotic_name",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#f8f9fa" }, // 🔹 Light grey background
          align: "left",
          formatter: (cell, row) => <span>{row.antibiotic_name}</span>,
        },
        {
          text: "Resistant (R) ",
          dataField: "resistance",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#fff3f3" }, // 🔹 Light red shade
          align: "center",
          formatter: (cellContent, list, rowIndex) => (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`resistance-${rowIndex}`}
                checked={list.resistance || false}
                onChange={() => this.handleCheckboxToggle(list, "resistance")}
              />
            </div>
          ),
        },
        {
          text: "Intermediate (I)",
          dataField: "intermediate",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#fffbea" }, // 🔹 Light yellow shade
          align: "center",
          formatter: (cellContent, list, rowIndex) => (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`intermediate-${rowIndex}`}
                checked={list.intermediate || false}
                onChange={() => this.handleCheckboxToggle(list, "intermediate")}
              />
            </div>
          ),
        },
        {
          text: "Sensitive (S)",
          dataField: "sensitive",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#eafaf1" }, // 🔹 Light green shade
          align: "center",
          formatter: (cellContent, list, rowIndex) => (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`sensitive-checkbox-${rowIndex}`}
                checked={list.sensitive || false}
                onChange={() => this.handleCheckboxToggle(list, "sensitive")}
              />
            </div>
          ),
        },
        {
          text: "Not Tested",
          dataField: "notTested",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#f0f0f0" }, // 🔹 Light grey shade
          align: "center",
          formatter: (cellContent, list, rowIndex) => (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`notTested-checkbox-${rowIndex}`}
                checked={list.notTested || false}
                onChange={() => this.handleCheckboxToggle(list, "notTested")}
              />
            </div>
          ),
        },
      ];
    }
  };
  handleFileUpload = (event) => {
    const file = event.target.files[0];
    console.log("handleFileUpload - selected file:", file);

    if (file) {
      const maxSize = 10 * 1024 * 1024; // 10 MB in bytes

      if (file.size > maxSize) {
        // ❌ File too large
        alert("Please upload file less than 10MB.");
        event.target.value = ""; // Reset file input
        this.setState({
          selectedFile: null,
          selectedFileName: "",
          fileMissing: true,
        });
        return;
      }

      // ✅ File valid
      this.setState({
        selectedFile: file,
        selectedFileName: file.name,
        fileMissing: false,
      });
    }
  };

  componentWillUnmount() {
    if (this.state.selectedFile instanceof File) {
      URL.revokeObjectURL(this.state.selectedFile);
    }
  }
  componentDidMount() {
    const { match, onGetSchemeAnalyte, onGetMicroresult } = this.props;
    const roundId = match.params.id;
    const userId = this.state.user_id;
    if (!userId) return;

    // Step 1: fetch scheme info
    onGetSchemeAnalyte(roundId);
  }

  componentDidUpdate(prevProps) {
    const {
      round_name,
      scheme,
      onGetMicroresult,
      match,
      ResultList,
      ListAntibiotic,
      ListOrganism,
    } = this.props;
    const currentRoundId = match.params.id;

    // 1️⃣ Fetch data when round_name first appears
    if (round_name && prevProps.round_name !== round_name) {
      console.log("📤 Dispatching GET_MICRO_RESULT_DATA saga");
      onGetMicroresult({
        userId: this.state.user_id,
        scheme: scheme || "",
        roundName: round_name,
        roundId: currentRoundId,
      });
    }

    // 2️⃣ Run combineData only if we now have the data we need
    const dataReady = ResultList.length > 0 || ListAntibiotic.length > 0;
    const dataChanged =
      ResultList !== prevProps.ResultList ||
      ListAntibiotic !== prevProps.ListAntibiotic;

    if (dataReady && dataChanged) {
      console.log("🆕 Data ready, combining...");
      this.combineData();
    }
  }
  combineData = () => {
    const {
      ResultList = [],
      ListAntibiotic = [],
      ListOrganism = [],
    } = this.props;
    const currentRoundId = this.props.match.params.id;

    const filteredResults = ResultList.filter(
      (r) => r.round_id == currentRoundId,
    );

    let combinedData = [];

    if (filteredResults.length > 0) {
      combinedData = filteredResults.map((item) => ({
        id: `db-${item.id ?? item.antibiotic_name}`, // React table key
        db_id: item.id || null, // Actual DB ID
        lab_id: item.participant_id,
        round_id: currentRoundId,
        antibiotic_name: item.antibiotic_name || "",
        resistance: !!item.resistance,
        intermediate: !!item.intermediate,
        sensitive: !!item.sensitive,
        notTested: !!item.not_tested,
        result_sheet_url: item.result_sheet || "",
        comment: item.comment || "",
        result_status: item.result_status || "Saved",
      }));

      const firstResult = filteredResults[0];
      const matchedOrg = ListOrganism.find(
        (o) => o.name === firstResult.organism,
      ) || { id: "", name: "" };

      this.setState({
        selectedOrganism: matchedOrg.id,
        selectedOrganismName: matchedOrg.name,
        selectedReagent: firstResult.reagent_name || "",
        selectedReagentAST: firstResult.ast_reagent_name || "",
        selectedInstrument: firstResult.instrument_name || "",
        selectedFile: firstResult.result_sheet || null,
        selectedFileName: firstResult.result_sheet?.split("/").pop() || "",
        combinedData,
        loading: false,
        isDataLoaded: true, // ✅ add this
      });
    } else if (ListAntibiotic.length > 0) {
      combinedData = ListAntibiotic.map((ab, index) => ({
        id: `${index}`,
        antibiotic_name: typeof ab === "string" ? ab : ab.name || "Unknown",
        resistance: false,
        intermediate: false,
        sensitive: false,
        notTested: false,
      }));

      this.setState({ combinedData, loading: false, isDataLoaded: true }); // ✅ add this
    } else {
      combinedData = [
        { id: "placeholder", antibiotic_name: "No antibiotics found" },
      ];
      this.setState({ combinedData, loading: false, isDataLoaded: true }); // ✅ add this
    }

    console.log("✅ combinedData set:", combinedData);
  };

  // ✅ New helper function to load data
  loadRoundData = async (roundId) => {
    const { onGetSchemeAnalyte, onGetMicroresult } = this.props;
    const userId = this.state.user_id;

    try {
      // Step 1: Fetch scheme info
      await onGetSchemeAnalyte(roundId);

      // Step 2: Wait until Redux updates props
      const { round_name, scheme } = this.props;

      if (round_name) {
        console.log("📤 Dispatching GET_MICRO_RESULT_DATA saga...");
        await onGetMicroresult({
          userId,
          scheme: scheme || "",
          roundName: round_name,
          roundId,
        });
      }
    } catch (err) {
      console.error("Error loading round data:", err);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleAntibioticChange = (e, row) => {
    const value = e.target.value;
    const updatedData = this.state.combinedData.map((item) =>
      item.id === row.id ? { ...item, antibiotic_id: value } : item,
    );
    this.setState({ combinedData: updatedData });
  };
  handleInstrumentChange = (event, list) => {
    const { value } = event.target;
    this.setState((prevState) => {
      const updatedData = prevState.combinedData.map((item) => {
        if (item.id === list.id) {
          const selectedInstrument = prevState.Instrument.find(
            (instr) => instr.id.toString() === value,
          );
          return {
            ...item,
            instrument_name: value, // Store the selected ID
            instrument_display_name: selectedInstrument
              ? selectedInstrument.name
              : "", // Display name
          };
        }
        return item;
      });
      return { combinedData: updatedData };
    });
  };
  handleCheckboxToggle = (item, field) => {
    const updatedData = this.state.combinedData.map((row) => {
      const isSameRow =
        (row.id && row.id === item.id) ||
        (!row.id && row.antibiotic_name === item.antibiotic_name);

      if (isSameRow) {
        // if the field is already true → uncheck it
        if (row[field] === true) {
          return {
            ...row,
            [field]: false,
          };
        }

        // otherwise → check this one, uncheck others
        return {
          ...row,
          resistance: false,
          intermediate: false,
          sensitive: false,
          notTested: false,
          [field]: true,
        };
      }
      return row;
    });

    this.setState({ combinedData: updatedData });
  };

  handleReagentChange = (event, list) => {
    const { value } = event.target;
    const { combinedData } = this.state;

    const updatedData = combinedData.map((item) => {
      if (item.id === list.id) {
        return { ...item, reagent_name: value };
      }
      return item;
    });

    this.setState({ combinedData: updatedData });
  };

  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  // ========================
  // 🔹 Save All
  // ========================
  handleSaveAll = async () => {
    const { combinedData, comments, selectedOrganism, selectedFile, user_id } =
      this.state;

    if (!combinedData.length) {
      alert("No results to save.");
      return;
    }
    if (!selectedFile) {
      this.setState({ fileMissing: true });
      return;
    }

    const organismId = Number(selectedOrganism);
    const organismName =
      this.props.ListOrganism.find((o) => Number(o.id) === organismId)?.name ||
      "";
    if (!organismId || !organismName) {
      alert("Please select an organism before saving results.");
      return;
    }

    try {
      await Promise.all(
        combinedData.map((row) => {
          const resultData = new FormData();
          if (row.db_id) resultData.append("id", row.db_id);

          resultData.append("scheme", this.props.schemeName || "");
          resultData.append("round_id", this.props.match.params.id);
          resultData.append("round_name", this.props.rounds || "");
          resultData.append("participant_id", parseInt(user_id, 10));
          resultData.append("organism", organismName);
          resultData.append("organism_id", organismId);
          resultData.append("antibiotic_name", row.antibiotic_name || "");
          resultData.append("resistance", row.resistance ? "true" : "false");
          resultData.append(
            "intermediate",
            row.intermediate ? "true" : "false",
          );
          resultData.append("sensitive", row.sensitive ? "true" : "false");
          resultData.append("not_tested", row.notTested ? "true" : "false");
          resultData.append("reagent_name", this.state.selectedReagent || "");
          resultData.append(
            "ast_reagent_name",
            this.state.selectedReagentAST || "",
          );
          resultData.append(
            "instrument_name",
            this.state.selectedInstrument || "",
          );
          resultData.append("result_status", "Saved");
          resultData.append("comment", comments || "");

          if (selectedFile instanceof File) {
            resultData.append("result_sheet", selectedFile, selectedFile.name);
          } else {
            resultData.append("result_sheet_url", selectedFile);
          }

          return this.props.onPostMicroResult(resultData, user_id);
        }),
      );

      alert("All microbiology results have been saved successfully.");
    } catch (error) {
      console.error("❌ Save error:", error);
      alert("Failed to save results. Please try again.");
    }
  };

  // 🔹 Submit All
  // ========================
  handleSubmitAll = async () => {
    const { combinedData, comments, selectedOrganism, selectedFile, user_id } =
      this.state;

    if (!combinedData.length) {
      alert("No results to submit.");
      return;
    }
    if (!selectedFile) {
      this.setState({ fileMissing: true });
      return;
    }

    const organismId = Number(selectedOrganism);
    const organismName =
      this.props.ListOrganism.find((o) => Number(o.id) === organismId)?.name ||
      "";

    if (!organismId || !organismName) {
      alert("Please select an organism before submitting results.");
      return;
    }

    try {
      await Promise.all(
        combinedData.map((row) => {
          const resultData = new FormData();
          if (row.db_id) resultData.append("id", row.db_id);

          resultData.append("scheme", this.props.schemeName || "");
          resultData.append("round_id", this.props.match.params.id);
          resultData.append("round_name", this.props.rounds || "");
          resultData.append("participant_id", parseInt(user_id, 10));
          resultData.append("organism", organismName);
          resultData.append("organism_id", organismId);
          resultData.append("antibiotic_name", row.antibiotic_name || "");
          resultData.append("resistance", row.resistance ? "true" : "false");
          resultData.append(
            "intermediate",
            row.intermediate ? "true" : "false",
          );
          resultData.append("sensitive", row.sensitive ? "true" : "false");
          resultData.append("not_tested", row.notTested ? "true" : "false");
          resultData.append("reagent_name", this.state.selectedReagent || "");
          resultData.append(
            "ast_reagent_name",
            this.state.selectedReagentAST || "",
          );
          resultData.append(
            "instrument_name",
            this.state.selectedInstrument || "",
          );
          resultData.append("result_status", "Submitted");
          resultData.append("comment", comments || "");

          if (selectedFile instanceof File) {
            resultData.append("result_sheet", selectedFile, selectedFile.name);
          } else {
            resultData.append("result_sheet_url", selectedFile);
          }

          return this.props.onPostMicroResult(resultData, user_id);
        }),
      );

      const now = new Date().toISOString();

      // ✅ Immediately update UI
      this.setState((prevState) => ({
        submittedOn: now,
        combinedData: prevState.combinedData.map((row) => ({
          ...row,
          result_status: "Submitted",
        })),
      }));

      localStorage.setItem("micro_submittedOn", now);

      alert("All microbiology results have been submitted successfully.");
    } catch (error) {
      console.error("❌ Submit error:", error);
      alert("Failed to submit results. Please try again.");
    }
  };

  // ========================
  // 🔹 Resubmit
  // ========================
  handleResubmit = async () => {
    const { combinedData, comments, selectedOrganism, selectedFile, user_id } =
      this.state;

    if (!combinedData.length) {
      alert("No results to resubmit.");
      return;
    }
    if (!selectedFile) {
      this.setState({ fileMissing: true });
      return;
    }

    const organismId = Number(selectedOrganism);
    const organismName =
      this.props.ListOrganism.find((o) => Number(o.id) === organismId)?.name ||
      "";

    if (!organismId || !organismName) {
      alert("Please select an organism before resubmitting results.");
      return;
    }

    try {
      await Promise.all(
        combinedData.map((row) => {
          const resultData = new FormData();
          if (row.db_id) resultData.append("id", row.db_id);

          resultData.append("scheme", this.props.schemeName || "");
          resultData.append("round_id", this.props.match.params.id);
          resultData.append("round_name", this.props.rounds || "");
          resultData.append("participant_id", parseInt(user_id, 10));
          resultData.append("organism", organismName);
          resultData.append("organism_id", organismId);
          resultData.append("antibiotic_name", row.antibiotic_name || "");
          resultData.append("resistance", row.resistance ? "true" : "false");
          resultData.append(
            "intermediate",
            row.intermediate ? "true" : "false",
          );
          resultData.append("sensitive", row.sensitive ? "true" : "false");
          resultData.append("not_tested", row.notTested ? "true" : "false");
          resultData.append("reagent_name", this.state.selectedReagent || "");
          resultData.append(
            "ast_reagent_name",
            this.state.selectedReagentAST || "",
          );
          resultData.append(
            "instrument_name",
            this.state.selectedInstrument || "",
          );
          resultData.append("result_status", "Submitted");
          resultData.append("comment", comments || "");

          if (selectedFile instanceof File) {
            resultData.append("result_sheet", selectedFile, selectedFile.name);
          } else {
            resultData.append("result_sheet_url", selectedFile);
          }

          return this.props.onPostMicroResult(resultData, user_id);
        }),
      );

      const now = new Date().toISOString();

      // ✅ Immediately update UI
      this.setState((prevState) => ({
        submittedOn: now,
        combinedData: prevState.combinedData.map((row) => ({
          ...row,
          result_status: "Submitted",
        })),
      }));

      localStorage.setItem("micro_submittedOn", now);

      alert("All microbiology results have been resubmitted successfully.");
    } catch (error) {
      console.error("❌ Resubmit error:", error);
      alert("Failed to resubmit results. Please try again.");
    }
  };

  render() {
    const approvedLabListColumns = this.getApprovedLabListColumns();
    const id = this.props.match.params.id;
    const { SearchBar } = Search;
    const { combinedData, isDataLoaded } = this.state;
    const { microResult } = this.state;
    const {
      schemeName,
      microresults,
      scheme_id,
      schemeType,
      rounds,
      issue_date,
      closing_date,
      cycle_no,
      round_status,
    } = this.props;
    console.log("Round Status:", this.props.round_status);
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="text-center mt-5">
          <h5>Loading round data...</h5>
        </div>
      );
    }
    const selectedOrganismObj = this.props.ListOrganism.find(
      (o) => Number(o.id) === Number(this.state.selectedOrganism),
    );

    const isNoGrowth =
      selectedOrganismObj &&
      selectedOrganismObj.name.toLowerCase() === "no growth";

    const pageOptions = {
      sizePerPage: 50,
      totalSize: combinedData.length > 0 ? combinedData.length : " ",
      custom: true,
    };

    if (!isDataLoaded) {
      // return <div>Loading...</div>;
    }
    if (!this.state.isDataLoaded) {
      return <div className="text-center mt-5">Loading round data...</div>;
    }
    const defaultSorted = [
      {
        dataField: "name", // or scheme_name, name, etc.
        order: "asc", // A to Z
      },
    ];

    const { organization_name } = this.props.match.params;
    const participant_id = this.props.match.params.id1;
    return (
      <React.Fragment>
        {schemeType ? (
          <div className="page-content">
            <MetaTags>
              <title>Participant Result | NEQAS</title>
            </MetaTags>
            <Container fluid>
              <Row className="mb-3 text-dark fs-6">
                <strong>
                  <Col className="d-flex flex-wrap justify-content-md-around justify-content-sm-start  p-3">
                    <div className="d-flex flex-column flex-md-row align-items-start  mb-2 mb-md-0 p-2">
                      <span className="me-2">Participant No:</span>
                      <span>{participant_id}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Scheme - Cycle: </span>
                      <span>
                        ({schemeName}) - {cycle_no}
                      </span>
                    </div>

                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Round No: </span>
                      <span>{rounds}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Issue Date:</span>
                      <span>{moment(issue_date).format("DD-MMM-YY")}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start p-2">
                      <span className="me-2">Closing Date: </span>
                      <span>{moment(closing_date).format("DD-MMM-YY")}</span>
                    </div>
                  </Col>
                </strong>
              </Row>
              <Row
                className="align-items-center mb-3"
                style={{ marginLeft: "25px", marginRight: "25px" }}
              >
                {/* COL 2 : Upload */}
                <Col md={2}>
                  <div className="d-flex flex-column">
                    <Button
                      color="primary"
                      onClick={() => this.fileInput.click()}
                      className="px-3 py-2 shadow-sm"
                      style={{ fontWeight: "500" }}
                    >
                      <i className="mdi mdi-upload me-2"></i>
                      Upload Result Sheet
                    </Button>

                    {/* Hidden File Input */}
                    <input
                      type="file"
                      accept=".xlsx, .xls, .csv, .pdf"
                      ref={(ref) => (this.fileInput = ref)}
                      style={{ display: "none" }}
                      onChange={this.handleFileUpload}
                    />

                    {/* File Name */}
                    {(this.state.selectedFileName ||
                      (this.state.combinedData.length > 0 &&
                        this.state.combinedData[0].result_sheet_url)) && (
                      <span
                        className="mt-2 text-primary"
                        style={{ cursor: "pointer", fontWeight: 500 }}
                        onClick={() => {
                          const fileToDownload =
                            this.state.selectedFile instanceof File
                              ? this.state.selectedFile
                              : this.state.selectedFile ||
                                this.state.combinedData[0].result_sheet_url;

                          this.downloadFile(fileToDownload);
                        }}
                      >
                        {this.state.selectedFileName ||
                          this.state.combinedData[0].result_sheet_url
                            .split("/")
                            .pop()}
                      </span>
                    )}

                    {/* File Missing Warning */}
                    {this.state.fileMissing && !this.state.selectedFile && (
                      <span className="mt-1 text-danger fw-bold">
                        * Please upload the result sheet
                      </span>
                    )}
                  </div>
                </Col>

                {/* COL 4 : Submitted On + Re-Submit */}
                <Col md={4}>
                  {this.state.submittedOn &&
                    this.state.combinedData.some(
                      (data) => data.result_status === "Submitted",
                    ) && (
                      <div className="text-muted">
                        <strong>Submitted On:</strong>{" "}
                        {moment(this.state.submittedOn).format(
                          "DD-MMM-YY, hh:mm:ss",
                        )}
                      </div>
                    )}
                </Col>

                <Col md={6} className="d-flex justify-content-end gap-2">
                  {(() => {
                    const roundStatus = (this.props.round_status || "")
                      .toLowerCase()
                      .trim();

                    const allSubmitted =
                      this.state.combinedData.length > 0 &&
                      this.state.combinedData.every(
                        (row) =>
                          (row.result_status || "").toLowerCase() ===
                          "submitted",
                      );

                    if (roundStatus.includes("closed")) return null;

                    // ✅ SHOW RE-SUBMIT HERE
                    if (allSubmitted) {
                      return (
                        <Button
                          color="primary"
                          style={{ minWidth: "140px", fontWeight: "500" }}
                          onClick={this.handleResubmit}
                        >
                          Re-Submit
                        </Button>
                      );
                    }

                    // ✅ OTHERWISE SHOW SAVE / SUBMIT
                    return (
                      <>
                        <Button
                          color="primary"
                          style={{ minWidth: "120px", fontWeight: "500" }}
                          onClick={this.handleSaveAll}
                        >
                          Save
                        </Button>
                        <Button
                          color="primary"
                          style={{ minWidth: "120px", fontWeight: "500" }}
                          onClick={this.handleSubmitAll}
                        >
                          Submit
                        </Button>
                      </>
                    );
                  })()}
                </Col>
              </Row>

              {/* ---------------- ORGANISM SECTION ---------------- */}

              <Row
                className="align-items-center mb-3"
                style={{ marginLeft: "25px", marginRight: "25px" }}
              >
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <label
                      className="form-label mb-0 me-2"
                      style={{ whiteSpace: "nowrap", width: "320px" }}
                    >
                      <strong>Select Organism:</strong>
                    </label>
                    <select
                      className="form-control"
                      value={this.state.selectedOrganism}
                      onChange={(e) =>
                        this.setState({ selectedOrganism: e.target.value })
                      }
                      style={{ maxWidth: "250px" }}
                    >
                      <option value="">Select Organism</option>
                      {this.props.ListOrganism?.map((org) => (
                        <option key={org.id} value={org.id}>
                          {org.name} ({org.code})
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>

              <Row
                className="align-items-center mb-3 mt-2 text-dark"
                style={{ marginLeft: "25px", marginRight: "25px" }}
              >
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <label
                      className="form-label mb-0 me-2"
                      style={{ whiteSpace: "nowrap", width: "320px" }}
                    >
                      <strong>
                        Select Reagent for Organism Identification:
                      </strong>
                    </label>
                    <select
                      className="form-control"
                      value={this.state.selectedReagent}
                      onChange={(e) =>
                        this.setState({ selectedReagent: e.target.value })
                      }
                    >
                      <option value="">Select Reagent</option>
                      {this.props.ReagentList?.map((reag, index) => (
                        <option key={index} value={reag.name || reag}>
                          {reag.name || reag}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>

              {!isNoGrowth && (
                <Row
                  className="align-items-center mb-3 mt-2 text-dark"
                  style={{ marginLeft: "25px", marginRight: "25px" }}
                >
                  <Col md={6}>
                    <div className="d-flex align-items-center">
                      <label
                        className="form-label mb-0 me-2"
                        style={{ whiteSpace: "nowrap", width: "320px" }}
                      >
                        <strong>Select Reagent for AST:</strong>
                      </label>
                      <select
                        className="form-control"
                        value={this.state.selectedReagentAST || ""}
                        onChange={(e) =>
                          this.setState({ selectedReagentAST: e.target.value })
                        }
                        style={{ maxWidth: "250px" }}
                      >
                        <option value="">Select Reagent</option>
                        {this.props.ReagentList?.map((reag, index) => (
                          <option key={index} value={reag.name || reag}>
                            {reag.name || reag}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                </Row>
              )}

              {!isNoGrowth && (
                <Row
                  className="align-items-center mb-3 mt-2 text-dark"
                  style={{ marginLeft: "25px", marginRight: "25px" }}
                >
                  <Col md={6}>
                    <div className="d-flex align-items-center">
                      <label
                        className="form-label mb-0 me-2"
                        style={{ whiteSpace: "nowrap", width: "320px" }}
                      >
                        <strong>Select Automated AST System (if used):</strong>
                      </label>
                      <select
                        className="form-control"
                        value={this.state.selectedInstrument}
                        onChange={(e) =>
                          this.setState({ selectedInstrument: e.target.value })
                        }
                      >
                        <option value="">Select Instrument</option>
                        {this.props.Instrument?.map((inst, index) => (
                          <option key={index} value={inst.name || inst}>
                            {inst.name || inst}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                </Row>
              )}

              {!isNoGrowth && (
                <Row className="justify-content-center align-item-center">
                  <Col lg="10">
                    <Card>
                      <CardBody>
                        <PaginationProvider
                          pagination={paginationFactory(pageOptions)}
                          keyField="id"
                          columns={approvedLabListColumns}
                          data={combinedData}
                        >
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField="id"
                              columns={approvedLabListColumns}
                              data={combinedData}
                              search
                            >
                              {(toolkitprops) => (
                                <div className="table-responsive">
                                  <BootstrapTable
                                    ref={this.node}
                                    bordered={false}
                                    classes="table table-bordered"
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                  />
                                  <PaginationListStandalone
                                    {...paginationProps}
                                    onPageChange={this.onPaginationPageChange}
                                  />
                                </div>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </Container>
          </div>
        ) : (
          <div>No scheme type available</div>
        )}
      </React.Fragment>
    );
  }
}
MicroResults.propTypes = {
  match: PropTypes.object,
  schemeName: PropTypes.string,
  microresults: PropTypes.string,
  schemeType: PropTypes.string,
  SchemeAnalytesList: PropTypes.array,
  rounds: PropTypes.string,
  round_status: PropTypes.string,
  result_type: PropTypes.string,
  scheme_id: PropTypes.number,
  issue_date: PropTypes.string,
  closing_date: PropTypes.string,
  cycle_no: PropTypes.string,
  ListAntibiotic: PropTypes.array,
  ListOrganism: PropTypes.array,
  Instrument: PropTypes.array,
  ReagentList: PropTypes.array,
  PostResult: PropTypes.array,
  ResultList: PropTypes.array,
  className: PropTypes.any,
  onGetSchemeAnalyte: PropTypes.func,
  onGetMicroresult: PropTypes.func,
  onPostMicroResult: PropTypes.func,
  // onGetResultsList: PropTypes.func,
  clearResultsState: PropTypes.func,
  clearAnalyteState: PropTypes.func,
  history: PropTypes.object.isRequired,
  scheme: PropTypes.string.isRequired, // or more specific if you know the shape
  round_name: PropTypes.string,
};
const mapStateToProps = (state) => {
  console.log("🔹 Entire Redux state in mapStateToProps:", state);

  const schemeState = state.SchemeAnalytesList || {};
  console.log("🟢 schemeState (state.SchemeAnalytesList):", schemeState);

  // Safe fallback arrays
  const antibiotics = schemeState.ListAntibiotic?.length
    ? schemeState.ListAntibiotic
    : schemeState.IdentificationResults?.map((r) => r.antibiotic) || [];
  console.log("🧪 Antibiotic List in mapStateToProps:", antibiotics);

  const organisms = schemeState.ListOrganism || [];
  console.log("🦠 Organism List in mapStateToProps:", organisms);

  const reagents = schemeState.ReagentList || [];
  console.log("🧴 Reagent List in mapStateToProps:", reagents);

  const instruments = schemeState.Instrument || [];
  console.log("⚙️ Instrument List in mapStateToProps:", instruments);

  const resultList = schemeState.ResultList || [];
  console.log("📄 ResultList in mapStateToProps:", resultList);

  const mappedProps = {
    schemeName: schemeState.schemeName || "",
    schemeType: schemeState.schemeType || "",
    rounds: schemeState.rounds || "",
    issue_date: schemeState.issue_date || "",
    closing_date: schemeState.closing_date || "",
    round_status: schemeState.round_status || "",
    cycle_no: schemeState.cycle_no || "",
    result_type: schemeState.result_type || "",
    scheme_id: schemeState.scheme_id || null,
    microresults: schemeState.microresults || [],
    ResultList: resultList,
    SchemeAnalytesList: schemeState.SchemeAnalytesList || [],
    scheme: schemeState.schemeName || "",
    round_name: schemeState.rounds || "",
    ListOrganism: organisms,
    ListAntibiotic: antibiotics,
    ReagentList: reagents,
    Instrument: instruments,
  };

  console.log("✅ Props returned from mapStateToProps:", mappedProps);
  return mappedProps;
};

const mapDispatchToProps = (dispatch) => ({
  onGetSchemeAnalyte: (id) => dispatch(getSchemeAnalytesList(id)),
  onPostMicroResult: (formData, id) => dispatch(postMicroResult(formData, id)),
  onGetMicroresult: (payload) => dispatch(getmicroresultdata(payload)),
  // any other actions you need...
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(MicroResults));
